/*@ngInject*/
const DropdownMediator = function () {

    this.getDropdownSelectedValueState = function (changes, currentSelectedOption, currentOptionList, placeholder) {
        const isSelectedValueChange = !_.isEmpty(changes.selectedValue);
        const isOptionListChange = !_.isEmpty(changes.optionList);

        if (isSelectedValueChange || isOptionListChange) {
            let selectedValue = _.get(currentSelectedOption, 'value');
            let selectedName = _.get(currentSelectedOption, 'name');

            if (isSelectedValueChange) {
                selectedValue = _.get(changes, 'selectedValue.currentValue');
                selectedName = _.get(changes, 'selectedName.currentValue') || selectedValue;
            }

            const selectedOption = this.findNewSelectedOption(selectedValue, selectedName, currentOptionList);

            const hasSelection = !_.isEmpty(selectedOption);
            const dropdownButtonDisplayText = hasSelection ?
                selectedOption.name.replace(/</g, '&lt;').replace(/>/g, '&gt;') : placeholder;

            return {
                hasSelection: hasSelection,
                selectedOption: selectedOption,
                dropdownButtonDisplayText: dropdownButtonDisplayText
            };
        }

        return null;
    };

    this.findNewSelectedOption = function (newSelectedValue, newSelectedName, optionList) {
        const isSelectedNewValueEmpty = _.isEmpty(newSelectedValue);
        let result = {};

        if (!isSelectedNewValueEmpty) {
            result = _.find(optionList, {value: newSelectedValue});

            const missingNewValueObject = _.isEmpty(result);
            if (missingNewValueObject) {
                result = {
                    name: newSelectedName,
                    value: newSelectedValue
                };
            }
        }

        return result;
    };
};

angular.module('umCore')
    .service('dropdownMediator', DropdownMediator);
